jQuery(function ($) {

    Shopify.Cart.ShippingCalculator.show( {
        submitButton: "Calcular", 
        submitButtonDisabled: "Calculando...",
        moneyFormat: moneyformat
    });
    
    function inputHandler(masks, max, event) {
        var c = event.target;
        var v = c.value.replace(/\D/g, "");
        var m = c.value.length > max ? 1 : 0;
        VMasker(c).unMask();
        VMasker(c).maskPattern(masks[m]);
        c.value = VMasker.toPattern(v, masks[m]);
    }
    var carregaFrete = function(cep) {
        if($("#address_zip").val().length != 9) {
            alert("Digite um cep válido")
        }else{
            var flag = true;
            $(".get-rates-custom").addClass("loading");
            $("#shipping-calculator2 .loading").addClass("load");
            $(".get-rates-custom").attr('value', 'Calculando...');
            
            $.getJSON("//viacep.com.br/ws/" + cep + "/json/?callback=?", function(dados) {
                if (!("erro" in dados)) {
                    if(!$("#shipping-calculator2.shiping-loaded")[0]) {
                        
                        $("#shipping-calculator2").addClass("shiping-loaded")
                    }
                    var state;
                    var uf = dados.uf.toUpperCase();
                    switch (uf) {
                        case "AC" :	state = "Acre";					break;
                        case "AL" :	state = "Alagoas";				break;
                        case "AM" :	state = "Amazonas";				break;
                        case "AP" :	state = "Amapá";				break;
                        case "BA" :	state = "Bahia";				break;
                        case "CE" :	state = "Ceará";				break;
                        case "DF" :	state = "Distrito Federal";		break;
                        case "ES" :	state = "Espírito Santo";		break;
                        case "GO" :	state = "Goiás";				break;
                        case "MA" :	state = "Maranhão";				break;
                        case "MG" :	state = "Minas Gerais";			break;
                        case "MS" :	state = "Mato Grosso do Sul";	break;
                        case "MT" :	state = "Mato Grosso";			break;
                        case "PA" :	state = "Pará";					break;
                        case "PB" :	state = "Paraíba";				break;
                        case "PE" :	state = "Pernambuco";			break;
                        case "PI" :	state = "Piauí";				break;
                        case "PR" :	state = "Paraná";				break;
                        case "RJ" :	state = "Rio de Janeiro";		break;
                        case "RN" :	state = "Rio Grande do Norte";	break;
                        case "RO" :	state = "Rondônia";				break;
                        case "RR" :	state = "Roraima";				break;
                        case "RS" :	state = "Rio Grande do Sul";	break;
                        case "SC" :	state = "Santa Catarina";		break;
                        case "SE" :	state = "Sergipe";				break;
                        case "SP" :	state = "São Paulo";			break;
                        case "TO" :	state = "Tocantíns";			break;
                      }
                    $('[name="address[province]"] option[value="' + state + '"]').prop('selected', true);
                    $('.get-rates').trigger('click');
                } else {
                    flag = false;
                    alert("CEP não encontrado");
                }
                $(".get-rates-custom").removeClass("loading");
                $(".get-rates-custom").attr('value', 'Calcular');
                
            }).fail(function(jqXHR) {
                alert("Consulta de CEP indisponivel no momento")
            });
        }
    }

    $(document).on('keypress', '#address_zip', function(event) {
        if(event.keyCode == 13) {
            event.preventDefault();
            $(".get-rates-custom").trigger("click")
        }
    });
    $(document).on('click', '.get-rates-custom', function() {
        var variantid = $("#variantid");
        if(variantid[0]) {
            var variantvalue = $("#variantid").val();
            var cartItens;

            jQuery.getJSON('/cart.js', function(cart) {
                cartItens = cart.item_count;
                if(cartItens == 0) {
                    console.log("adicionando...")
                    Shopify.addItem(variantvalue, 1, function(){
                        console.log('Success!!!')
                        carregaFrete($('#address_zip').val());
                        setTimeout(function() {
                            Shopify.removeItem(variantvalue);
                            console.log("Cart clean");
                        }, 10000);
                    });
                }else {
                    console.log(cartItens + " - itens no carrinho")
                    carregaFrete($('#address_zip').val());
                } 
            });
        }else {
            carregaFrete($('#address_zip').val());
        }
    });
});
